import { AnalyticsInterface } from './AnalyticsInterface';
import { EmptyAnalytics } from './EmptyAnalytics';
import { MatomoAnalytics } from './MatomoAnalytics';

export const analytics: AnalyticsInterface =
  process.env.NODE_ENV === 'development' ? new EmptyAnalytics() : new MatomoAnalytics();
